
import { mapActions, mapGetters, mapMutations } from 'vuex'
import {
  generateOrderCode,
  getFormattedDateTwoDaysLater,
} from '../utils/functionGlobais'

export default {
  data() {
    return {
      orderCode: generateOrderCode(),
      dueDateTwoDays: getFormattedDateTwoDaysLater(),
      overlayCardCredit: false,
      overlayCardCreditToken: false,
      overlayPix: false,
      overlayBoleto: false,
      termoCondicoes: false,
      overlayCaptureTicket: false,
      viewFormPaymentCreditCard: true,
      viewPedido: false,
      paymentMethod: '',
      paymentOption: '',
      tokenRecaptcha: '',
      referenciaPix: '',
      e1: 1,
      productVenda: [],
      message: [],
      viewCreditCard: {},
      boletoData: {},
      pixData: {},
      token: '',
      cartaoCredito: {
        token: '',
        numeroCartao: '',
        dataExpiracao: '',
        parcelas: '',
      },
      registerBuyer: {
        endereco: {
          cep: '',
          pais: 'Brasil',
        },
      },
      registerBuyerVenda: {},
      dataFormCard: {
        nomeImpresso: '',
        numeroCartao: '',
        dataExpiracao: '',
        codigoSeguranca: '',
        parcelas: '',
      },
      configToast: {
        timeout: false,
        position: 'top-center',
      },
    }
  },

  computed: {
    ...mapGetters('cart', ['productCart', 'totalCart', 'totalCartPrice']),
    ...mapGetters('unidade', ['unidadeInformation']),
    ...mapGetters('cupom', ['descontoDoCupom']),
    ...mapGetters('sdagenda', ['sdagenda']),
  },

  async mounted() {
    try {
      await this.$recaptcha.init()
    } catch (e) {
      console.error(e)
    }
  },
  beforeDestroy() {
    this.$recaptcha.destroy()
  },

  methods: {
    ...mapMutations('cart', ['CLEAN_CART']),
    ...mapMutations('cupom', ['CLEAN_CUPOM']),
    ...mapActions('sdagenda', ['captureTicket']),
    ...mapActions('dataClient', ['adicionarClient', 'adicionarCartClient']),
    ...mapActions('digisac', ['actionSendMessage']),
    ...mapActions('payment-cielo', [
      'createTokenCreditCardCielo',
      'paymentCreditCardCielo',
    ]),
    ...mapActions('payment-safe2pay', [
      'boletoPayment',
      'pixPayment',
      'createTokenCreditCardSafe2Pay',
      'paymentCreditCardSafe2Pay',
    ]),
    async generateTokenReCaptcha() {
      try {
        const token = await this.$recaptcha.execute()
        this.tokenRecaptcha = token
        this.checkVerifyReCaptcha()
      } catch (error) {
        console.error(error)
      }
    },

    async handlePaymentProcessing() {
      const formValidate = this.$refs.form.validate()
      if (!formValidate) {
        this.$toast.error('Preencha todos os campos obrigatórios')
        return false
      }

      if (!this.paymentMethod) {
        return this.$toast.info('Selecione forma de pagamento', {
          position: 'top-center',
        })
      }

      if (this.paymentMethod === 'Boleto') {
        await this.processingBoleto()
      } else if (this.paymentMethod === 'Pix') {
        await this.processingPix()
      } else if (this.paymentMethod === 'CartaoCreditoCielo') {
        this.registerNext()
      } else if (this.paymentMethod === 'CartaoCreditoSafe2pay') {
        this.registerNext()
      }
    },

    generateSalesInformation() {
      this.productVenda = this.productCart.map((product) => {
        const precoUnitario = this.descontoDoCupom(product.valorVenda)

        const desconto = product.valorVenda - precoUnitario

        const splits = product.splits.map((e, index) => {
          if (index === 0) {
            return {
              valorComissao: e.valorComissao - desconto,
              idReceiver: e.idReceiver,
            }
          } else {
            return e
          }
        })
        return {
          sku: product.sku,
          id: product.id,
          descricao: product.nomeVenda,
          precoUnitario,
          quantidade: product.quantity,
          splits,
        }
      })

      this.message = this.productCart.map(
        (product) => `produto: ${product.nomeVenda}`
      )
      const cpfCnpjSemCaracters = this.registerBuyer.cpfCnpj.replace(/\D/g, '')
      this.registerBuyerVenda = {
        ...this.registerBuyer,
        cpfCnpj: cpfCnpjSemCaracters,
      }
    },

    async processingTokenCreditCardSafe2Pay() {
      const formValidate = this.$refs.cardForm.validate()
      if (!formValidate) {
        return false
      }
      this.overlayCardCreditToken = true
      try {
        const { parcelas, ...dataWithoutParcelas } = this.dataFormCard
        const numeroCartao = dataWithoutParcelas.numeroCartao.replace(/\s/g, '')
        const dataToHaveToken = {
          ...dataWithoutParcelas,
          numeroCartao,
          vendedor: this.unidadeInformation.cpfcnpj,
        }
        const data = await this.createTokenCreditCardSafe2Pay(dataToHaveToken)
        this.cartaoCredito.token = data.token
        this.cartaoCredito.numeroCartao = data.numeroCartao
        this.cartaoCredito.dataExpiracao = data.dataExpiracao
        this.cartaoCredito.parcelas = this.dataFormCard.parcelas
        this.viewCreditCard = data
        this.viewPedido = true
        this.viewFormPaymentCreditCard = false
        this.$toast.clear()
        this.toScroll()
      } catch (error) {
        console.error(error)
        const data = await error.response.data
        if (!data.mensagem) {
          return this.$toast.error(
            'Houve um erro token!' + error,
            this.configToast
          )
        }
        this.$toast.error(data.mensagem, this.configToast)
      } finally {
        this.overlayCardCreditToken = false
      }
    },

    async processingCreditCardSafe2Pay() {
      this.overlayCardCredit = true
      const cnpj = this.unidadeInformation.cpfcnpj
      try {
        this.generateSalesInformation()
        const isDev = this.$isDev ? 'asdf' : this.cartaoCredito.token
        const paymentData = {
          vendedor: cnpj,
          split: true,
          referencia: `${this.orderCode}EC`,
          sandbox: false,
          cartaoCredito: {
            token: isDev,
            ...this.cartaoCredito,
          },
          comprador: this.registerBuyerVenda,
          produtos: this.productVenda,
        }
        const data = await this.paymentCreditCardSafe2Pay(paymentData)

        if (data.mensagem !== 'Pagamento Autorizado') {
          this.$toast.error('pagamento: ' + data.mensagem, this.configToast)
          this.$toast.error('Descrição: ' + data.descricao, this.configToast)
        } else {
          this.adicionarClient(this.registerBuyer)
          const productPedido = this.productVenda.map((product) => {
            return {
              id: generateOrderCode(),
              ...product,
            }
          })
          this.adicionarCartClient(productPedido)
          this.$router.push({
            path: '/pagamento-realizado',
            query: {
              mensagem: data.mensagem,
              idTransacao: data.idTransacao,
              funcao: data.funcao,
            },
          })
          this.CLEAN_CART()
          this.CLEAN_CUPOM()
          this.sendMessage(data, this.registerBuyerVenda)
          if (this.sdagenda.status === false) {
            const clientCaptureTicket = {
              organization: paymentData.vendedor,
              cliente: this.registerBuyerVenda,
              referencia: paymentData.referencia,
              idTransacao: data.idTransacao,
            }
            this.fetchTicket(clientCaptureTicket)
          }
        }
      } catch (error) {
        const data = await error.response.data
        if (!data.mensagem) {
          return this.$toast.error(
            'Houve um erro ao finalizar compra! ' + error,
            this.configToast
          )
        }
        this.$toast.error(data.mensagem)
      } finally {
        this.overlayCardCredit = false
      }
    },
    async processingTokenCreditCardCielo() {
      const formValidate = this.$refs.cardForm.validate()
      if (!formValidate) {
        return false
      }

      this.overlayCardCreditToken = true
      try {
        const numeroCartao = this.dataFormCard.numeroCartao.replace(/\s/g, '')
        const dataToHaveToken = {
          ...this.dataFormCard,
          nomeComprador: this.registerBuyer.nome,
          numeroCartao,
        }
        const data = await this.createTokenCreditCardCielo(dataToHaveToken)
        this.token = data.token
        this.viewPedido = true
        this.viewFormPaymentCreditCard = false
        this.$toast.clear()
        this.toScroll()
      } catch (error) {
        this.$toast.error('error: ' + error, this.configToast)
      } finally {
        this.overlayCardCreditToken = false
      }
    },
    async processingCreditCardCielo() {
      this.overlayCardCredit = true
      try {
        const paymentData = {
          pedidoId: this.orderCode,
          comprador: {
            nome: this.registerBuyer.nome,
          },
          pagamento: {
            tipo: 'CreditCard',
            valor: this.totalCartPrice,
            parcelas: 1,
            cartaoCredito: {
              token: this.token,
              bandeira: this.dataFormCard.bandeira,
            },
          },
        }
        const data = await this.paymentCreditCardCielo(paymentData)
        if (data.pagamento.mensagem !== 'Operation Successful') {
          this.$toast.error('error: ' + data.pagamento.mensagem)
        } else {
          this.CLEAN_CART()
          this.CLEAN_CUPOM()
          this.$router.push({
            path: '/pagamento-realizado',
            query: {
              mensagem: data.pagamento.mensagem,
              pedidoId: data.pedidoId,
              valor: data.pagamento.valor,
            },
          })
        }
      } catch (error) {
        this.$toast.error(error)
        console.error(error)
      } finally {
        this.overlayCardCredit = false
      }
    },

    async processingBoleto() {
      this.overlayBoleto = true
      try {
        this.generateSalesInformation()
        const cnpj = this.unidadeInformation.cpfcnpj
        const paymentData = {
          vendedor: cnpj,
          split: true,
          referencia: `${this.orderCode}EC`,
          boleto: {
            dataVencimento: this.dueDateTwoDays,
            instrucao: 'Prazo de liberação de 2 dias',
            mensagens: this.message,
          },
          comprador: this.registerBuyerVenda,
          produtos: this.productVenda,
        }
        const data = await this.boletoPayment(paymentData)
        this.boletoData = data
        this.registerNext()
        this.CLEAN_CART()
        this.CLEAN_CUPOM()
        this.sendMessage(data, this.registerBuyerVenda)
      } catch (error) {
        const data = await error.response.data
        if (!data.mensagem) {
          return this.$toast.error('error boleto: ' + error, this.configToast)
        }
        this.$toast.error(data.mensagem)
      } finally {
        this.overlayBoleto = false
      }
    },

    async processingPix() {
      this.overlayPix = true
      try {
        this.generateSalesInformation()
        const cnpj = this.unidadeInformation.cpfcnpj
        const paymentData = {
          vendedor: cnpj,
          split: true,
          referencia: `${this.orderCode}EC`,
          pix: {
            tempoExpiracao: '2880',
          },
          comprador: this.registerBuyerVenda,
          produtos: this.productVenda,
        }
        const data = await this.pixPayment(paymentData)
        this.pixData = data
        this.registerNext()
        this.adicionarClient(this.registerBuyer)
        const productPedido = this.productVenda.map((product) => {
          return {
            id: generateOrderCode(),
            ...product,
          }
        })
        this.adicionarCartClient(productPedido)
        this.sendMessage(data, this.registerBuyerVenda)
        this.referenciaPix = paymentData.referencia
      } catch (error) {
        const data = await error.response.data
        if (!data.mensagem) {
          return this.$toast.error('error pix: ' + error)
        }
        this.$toast.error(data.mensagem)
      } finally {
        this.overlayPix = false
      }
    },

    async sendMessage(paymente, buyerInfo) {
      const number = buyerInfo.telefone.replace(/[^0-9]/g, '')
      const message = {
        text: `Obrigado por escolher a Senha Digital.
Seu pedido foi gerado com sucesso ✅!

Para verificar o status de pagamento e agendamento utilize o código do pedido ${paymente.idTransacao} acessando: ${window.location.origin}/status-pagamento.

Obs.: Em caso de pagamento com boleto, o agendamento será liberado após a compensação.

Esta é uma mensagem automática, para falar com nosso atendimento visite: ${window.location.origin}/contato.

Estamos à disposição para esclarecer eventuais dúvidas.😊
`,
        number,
      }
      try {
        await this.actionSendMessage(message)
      } catch (error) {
        console.error(error)
        const data = await error.response.data
        if (!data.message) {
          return console.error('error mensagem whatsapp: ' + error)
        }
        console.error(data.message)
      }
    },

    // função para captura ticket para situações onde links/whiteLabel optarem por não ter agenda
    async fetchTicket(value) {
      this.overlayCaptureTicket = true
      try {
        const infoTicket = {
          organization: value.organization,
          idTransacao: value.idTransacao.toString(),
          referencia: value.referencia,
          client: {
            cpfcnpj: value.cliente.cpfCnpj,
            name: value.cliente.nome,
          },
        }
        await this.captureTicket(infoTicket)
      } catch (error) {
        console.error(error)
        this.$toast.error('Coleta ticket falhou, entre em contato com suporte!')
      } finally {
        this.overlayCaptureTicket = false
      }
    },

    dataFetchCnpj(data) {
      console.log(data)
      this.registerBuyer.nome = data.razao || ''
      // this.registerBuyer.email = data.email
      // this.registerBuyer.telefone = `(${data.ddd_1})${data.tel_1}`
      this.registerBuyer.endereco.cep = data.log_cep || ''
      this.registerBuyer.endereco.bairro = data.log_bairro || ''
      this.registerBuyer.endereco.logradouro = data.log_nome || ''
      this.registerBuyer.endereco.complemento = data.log_comp || ''
      this.registerBuyer.endereco.estado = data.log_uf || ''
      this.registerBuyer.endereco.cidade = data.log_municipio || ''
    },

    registerNext() {
      this.paymentOption = this.paymentMethod
      this.e1 = 3
      this.toScroll()
    },

    orderSummarReturn() {
      this.viewPedido = false
      this.viewFormPaymentCreditCard = true
      this.$toast.clear()
    },

    cartNext() {
      this.e1 = 2
      this.toScroll()
    },

    registerReturn() {
      this.e1 = 1
      this.toScroll()
    },
    creditCardReturn() {
      this.e1 = 2
      this.toScroll()
    },
    toScroll() {
      const top = window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
      return top
    },
  },
}
